import z from "zod";
import {passwordSchema} from "../common/passwordSchema";

const passwordSetRequestSchema = z.object({
    token: z.string().uuid(),
    newPassword: passwordSchema,
    newPasswordConfirmation: z.string(),
}).refine(data => data.newPassword === data.newPasswordConfirmation, {
    message: 'Hesla se neshodují',
    path: ['newPasswordConfirmation'],
});

type PasswordSetSchema = z.infer<typeof passwordSetRequestSchema>;

export {passwordSetRequestSchema, type PasswordSetSchema};
